
/* injects from baggage-loader */

import { PlatesType } from '../types/plates';

// Norte
import norteDevice from '_images/locales/norte/device.png';

// Sudeste
import sudesteDevice from '_images/locales/sudeste/device.png';

// Centro oeste
import centrooesteDevice from '_images/locales/centrooeste/device.png';

//chef
import chefDevice from '_images/locales/chef/book.png';

export const norte = {
    device: {
        url: norteDevice,
        type: 'tablet',
        tabs: false
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance
        },        
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink
        },        
    ]
}

//Centrooeste
export const centrooeste = {
    device: {
        url: centrooesteDevice,
        type: 'tablet',
        tabs: true
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: true
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false
        },          
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: true
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },       
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: false
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: false
        }        
    ]
}


//sudeste
export const sudeste = {
    device: {
        url: sudesteDevice,
        type: 'tablet',
        tabs: true
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: true
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false
        },         
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: true
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true
        },        
    ]
}

// Nordeste
import nordesteDevice from '_images/locales/nordeste/device.png';

export const nordeste = {
    device: {
        url: nordesteDevice,
        type: 'notepad',
        tabs: false
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance
        },        
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink
        },        
    ]
}

// Sul
export const sul = {
    device: {
        url: nordesteDevice,
        type: 'notepad',
        tabs: false
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance
        },        
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink
        },        
    ]
}

// chef
//sudeste
export const chef = {
    device: {
        url: chefDevice,
        type: 'tablet',
        tabs: true
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: true
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false
        },         
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: true
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true
        },        
    ]
}

export default {
    norte,
    nordeste,
    sul,
    sudeste,
    centrooeste,
    chef
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-device/tab-device.const.js